module.exports = __webpack_public_path__ + "static/media/gallery04.153f0fb7.gif";